import React from 'react';
import './index.less';
import pic1 from './img/image1.png';
import pic2 from './img/image2.png';
import pic3 from './img/image3.png';
import pic4 from './img/image4.png';
import pic5 from './img/image5.png';
import pic6 from './img/image2.png';
import pic7 from './img/image7.png';
import pic8 from './img/image8.png';
import btn from './img/image-btn.png';


class CarAuthorization extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    console.log()
    return (
      <div id="bgDiv">
        <div className="relative-view">
          <img src={pic1} />
          <div className="absolute-view">
            <a className="download-link" href={window.location.origin + '/appDownload/#/HuilianDownload'}>
              <img className="download-btn" src={btn} />
            </a>
          </div>
        </div>

        <img src={pic2} />
        <img src={pic3} />
        <img src={pic4} />
       
        <div className="relative-view">
          <img src={pic5} />
          <div className="absolute-view">
            <a className="download-link" href={window.location.origin + '/appDownload/#/HuilianDownload'}>
              <img className="download-btn" src={btn} />
            </a>
          </div>
        </div>
        <img src={pic6} />
        <img src={pic7} />
        <img src={pic8} />

      </div>
    );
  }
}

export default CarAuthorization;



// WEBPACK FOOTER //
// ./src/staticPage/carAuthorization/index.js